import { render, staticRenderFns } from "./StateCard.vue?vue&type=template&id=131a4b83"
import script from "./StateCard.vue?vue&type=script&lang=js"
export * from "./StateCard.vue?vue&type=script&lang=js"
import style0 from "./StateCard.vue?vue&type=style&index=0&id=131a4b83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports